export interface FeatureUpdateDraftSection {
  id: string;
  type: "text" | "image";
  content: string;
}

export interface FeatureUpdateEditorDraft {
  title: string;
  sections: FeatureUpdateDraftSection[];
}

export interface GeneratedFeatureUpdateImageDraft {
  title: string;
  body: string;
}

export function hasFeatureUpdateGuidance(draft: FeatureUpdateEditorDraft): boolean {
  return (
    draft.title.trim().length > 0 ||
    draft.sections.some(section => section.type === "text" && section.content.trim().length > 0)
  );
}

export function upsertFeatureUpdateImage(
  sections: FeatureUpdateDraftSection[],
  imageUrl: string,
  targetId: string | null,
  newId: () => string,
): FeatureUpdateDraftSection[] {
  const target = targetId ? sections.find(section => section.id === targetId) : undefined;
  return target?.type === "image"
    ? sections.map(section => section.id === targetId ? { ...section, content: imageUrl } : section)
    : [...sections, { id: newId(), type: "image", content: imageUrl }];
}

export function applyGeneratedFeatureUpdateImageDraft(
  latest: FeatureUpdateEditorDraft,
  generated: GeneratedFeatureUpdateImageDraft,
  requestId: number,
  currentRequestId: number,
  newId: () => string,
): { applied: boolean; draft: FeatureUpdateEditorDraft } {
  if (requestId !== currentRequestId || hasFeatureUpdateGuidance(latest)) {
    return { applied: false, draft: latest };
  }

  const emptyTextIndex = latest.sections.findIndex(
    section => section.type === "text" && !section.content.trim(),
  );
  const sections = emptyTextIndex >= 0
    ? latest.sections.map((section, index) =>
        index === emptyTextIndex ? { ...section, content: generated.body } : section)
    : [{ id: newId(), type: "text" as const, content: generated.body }, ...latest.sections];

  return {
    applied: true,
    draft: { title: generated.title, sections },
  };
}